module.exports = __webpack_public_path__ + "static/img/publicar1024x768.2f9efa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/publicar/publicar1024x768.jpg
// module id = xtZL
// module chunks = 47